import angular = require("angular");
import TPL = require("templates");

/**
  Simple horizontal/vertical separator
  params:
    type: "horizontal" | "vertical"
    text: string, a text to be shown in the middle of the line
*/
export class SeparatorDirective {

  template = TPL.commonDirectives.separator;
  scope = {
    params: "=params"
  };

  static factory() {
    return () => new SeparatorDirective();
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/common/separator.ts
 **/